import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { compose } from 'redux';

import CompanySignupForm from 'common/auth/CompanySignupForm';
import CreateCompanyForm from 'common/company/CreateCompanyForm';
import CreateOrUpdateCompanyForm from 'common/company/CreateOrUpdateCompanyForm';
import { TrackEventContext } from 'common/containers/EventContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import RegisterHelmet from 'common/helmets/RegisterHelmet';
import LazyLoadedImage from 'common/LazyLoadedImage';
import getFirstName from 'common/util/getFirstName';
import withContexts from 'common/util/withContexts';
import Zeb from 'img/landing/zeb.webp';

import 'css/components/_Register.scss';

class Register extends Component {
  static propTypes = {
    referrer: PropTypes.shape({ name: PropTypes.string }),
    router: PropTypes.object,
    trackEvent: PropTypes.func,
    viewer: PropTypes.shape({
      loggedOut: PropTypes.bool,
    }),
  };

  state = {
    trialPlan: this.props.location.query.trial,
  };

  componentDidMount() {
    const { trackEvent } = this.props;
    trackEvent('Viewed Register Page');
    trackEvent('Intent to Register');
  }

  onSuccess = ({ companies, subdomain }) => {
    const getSubdomainURL = (subdomain) =>
      `${window.location.protocol}//${subdomain}.${window.location.host}/admin/onboarding/redirect`;
    let redirectionURL = '';

    if (companies) {
      const company =
        companies.find((company) => !company.integrationAuthRedirectionURL) ?? companies[0];
      redirectionURL = company.integrationAuthRedirectionURL ?? getSubdomainURL(company.subdomain);
    } else if (subdomain) {
      redirectionURL = getSubdomainURL(subdomain);
    }

    window.location.assign(redirectionURL);
  };

  renderForm() {
    const { viewer } = this.props;
    const { trialPlan } = this.state;
    if (!viewer || viewer.loggedOut) {
      return <CompanySignupForm onSuccess={this.onSuccess} trialPlan={trialPlan} />;
    } else {
      return <CreateCompanyForm onSuccess={this.onSuccess} trialPlan={trialPlan} />;
    }
  }

  renderContents() {
    const { trialPlan } = this.state;
    const { referrer, viewer } = this.props;

    let subheader = referrer ? (
      <>Get 20% off your monthly plan for 3 months or 5% off your first year of an annual plan.</>
    ) : (
      <>Get started with Canny for&nbsp;free</>
    );
    if (trialPlan === 'growth') {
      subheader = <>Start your Canny Growth trial for&nbsp;free</>;
    } else if (trialPlan === 'starter') {
      subheader = <>Try your Canny Starter trial for&nbsp;free</>;
    }

    if (viewer && viewer.companies && viewer.companies.length > 0 && trialPlan) {
      return <CreateOrUpdateCompanyForm trialPlan={trialPlan} />;
    }

    const header = referrer
      ? `${getFirstName(referrer.name)} has invited you to Canny!`
      : `Easily gather, track, and manage user feedback`;

    return (
      <div className="registerContainer">
        <div className="left">
          <div className="contents">
            <h1 className="header">{header}</h1>
            <h2 className="subheader">{subheader}</h2>
            {this.renderForm()}
          </div>
        </div>
        <div className="right">
          <div className="contents">
            <div className="text">
              <div className="quote">
                "Canny intrinsically provides us with a way of connecting and communicating with the
                people that matter most to our&nbsp;product."
              </div>
              <div className="credit">– Zeb Evans, Founder & CEO at&nbsp;ClickUp</div>
            </div>
            <div className="imageContainer">
              <LazyLoadedImage className="zeb" loading="eager" src={Zeb} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="register">
        <RegisterHelmet />
        {this.renderContents()}
        <div className="agree">
          By signing up, you agree to our{' '}
          <a href="https://canny.io/terms" target="_blank" rel="noopener">
            terms of service
          </a>{' '}
          and{' '}
          <a href="https://canny.io/privacy" target="_blank" rel="noopener">
            privacy&nbsp;policy.
          </a>
        </div>
      </div>
    );
  }
}

export default compose(
  withContexts({
    trackEvent: TrackEventContext,
    viewer: ViewerContext,
  })
)(Register);
